"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerPeriodAveragePrice = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_1 = __importDefault(require("moment"));
const app_1 = require("../../../../app");
const helpers_1 = require("../../../../utils/helpers");
const chart_view_1 = require("../../../../widgets/chart_view");
let config = {
    type: 'line',
    data: {
        labels: [],
        datasets: [{
                label: 'Valeur des réservations (EUR)',
                backgroundColor: chart_view_1.chartColors.red,
                borderColor: chart_view_1.chartColors.red,
                data: [],
                fill: false,
            }, {
                label: 'Durée totale réservations (H)',
                yAxisID: 'B',
                backgroundColor: chart_view_1.chartColors.green,
                borderColor: chart_view_1.chartColors.green,
                data: [],
                fill: false,
            }, {
                label: 'Valeur moyenne de l\'heure réservée (EUR)',
                yAxisID: 'C',
                backgroundColor: chart_view_1.chartColors.blue,
                borderColor: chart_view_1.chartColors.blue,
                data: [],
                fill: false,
            }]
    },
    options: {
        aspectRatio: (0, helpers_1.responsiveValues)(1, 5),
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: 'Volume des réservations'
        },
        tooltips: {
            mode: 'point',
            intersect: false,
        },
        hover: {
            mode: 'point',
            intersect: false
        },
        scales: {
            xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Mois'
                    }
                }],
            yAxes: [{
                    id: 'A',
                    display: true,
                    gridLines: {
                        display: false,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Total (EUR)'
                    }
                }, {
                    id: 'B',
                    display: true,
                    gridLines: {
                        display: false,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Temps (H)'
                    }
                }, {
                    id: 'C',
                    display: false,
                    gridLines: {
                        display: false,
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'Prix Moyen'
                    }
                }]
        }
    }
};
exports.PerPeriodAveragePrice = {
    loaded: false,
    options: config,
    period: 'day',
    periodStart: (0, moment_1.default)().format("YYYY-MM-01"),
    refresh(period, periodStart) {
        this.period = period;
        this.periodStart = periodStart;
        return this.getData();
    },
    getData() {
        return app_1.App
            .get(`/stats/per_period_average_price?period=${this.period}&period_start=${this.periodStart}`)
            .then((items) => {
            let o = this.options;
            o.data.labels = items.labels.map((d) => (0, moment_1.default)(d).format("L"));
            o.data.datasets[0].data = items.revenues;
            o.data.datasets[1].data = items.duration;
            o.data.datasets[2].data = items.average_value_per_hour;
            mithril_1.default.redraw();
        });
    },
    randomizeData() {
    }
};
